<iframe [src]="sanitizedSource"></iframe>